"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = calculateOptimalSpacingTimeInMins;
function calculateOptimalSpacingTimeInMins(s) {
  return 24 * 60 * (1.5 * Math.pow(s, 2) + 1.5 * s - 2);
}